






















import { Component, Vue, Watch } from "vue-property-decorator";
import { AppModule } from "@/store/modules/app";
import SidebarItem from "./SidebarItem.vue";
import { ApiClient } from '@/api/ApiClient';
import { Route } from "vue-router";

@Component({
  components: {
    SidebarItem
  }
})
export default class SideBar extends Vue {

  get sidebar() {
    return AppModule.sidebar;
  }

  get routes() {
    return (this.$router as any).options.routes;
  }

  get isCollapse() {
    return !this.sidebar.opened;
  }

  public account: any = { roles: [] };

  public mounted () {
    this.initAcconut()
  }

  public async initAcconut() {
    this.account.roles = this.$store.state.user.roles;
  }

  //
  @Watch("$route")
  private async onRouteChange(route: Route) {
    this.account.roles = this.$store.state.user.roles;
  }

}
